import { useEffect } from "react";
import { FieldValues, UseFormWatch, WatchObserver } from "react-hook-form";

export const useFormWatchAll = <FormValues extends FieldValues>(
  formWatch: UseFormWatch<FormValues>,
  watchAllCallback?: WatchObserver<FormValues>,
) => {
  useEffect(() => {
    if (watchAllCallback) {
      const { unsubscribe } = formWatch(watchAllCallback);
      return unsubscribe;
    }
  }, [watchAllCallback, formWatch]);
};
